import theme from '@styles/theme';
export default {
  headerContent: (haveFilters: boolean) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    p: haveFilters ? ['0 24px', '0 24px', '0 40px', '0 40px', '0 8.072916667vw'] : ['0 24px 24px', '0 24px 24px', '0 40p 24px', '0 40px 40px', '0 8.072916667vw 40px']
  }),
  titleWrapper: {
    display: 'flex',
    alignItems: 'flex-end',
    mb: '16px'
  },
  titleCount: {
    fontFamily: theme.fonts.uniform,
    fontSize: [theme.fontSizes.h4, theme.fontSizes.h4, theme.fontSizes.h4, theme.fontSizes.h4, theme.fontSizes.h3],
    lineHeight: '140%',
    letterSpacing: theme.letterSpacings.caps,
    paddingLeft: '4px'
  },
  descriptionText: {
    fontSize: theme.fontSizes.text,
    width: ['100%', '100%', '100%', '51.458333333vw']
  }
};